<template>
  <div class="home-nav pt-2">
    <b-navbar class="container" variant="faded" type="dark">
      <b-navbar-brand to="/">
        <HeaderLogo :inline="true" />
      </b-navbar-brand>

      <b-navbar-nav class="ml-auto">
        <b-nav-item @click="logout">Log out</b-nav-item>
      </b-navbar-nav>
    </b-navbar>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import HeaderLogo from "../../views/HeaderLogo.vue";
import { setToken } from "../../helpers/session";

export default {
  components: { HeaderLogo },
  data() {
    return {};
  },
  mounted() {
    this.fetchCurrentUser();
  },
  methods: {
    ...mapActions("layout", ["fetchCurrentUser"]),
    logout() {
      setToken("");
      location.reload();
    }
  }
};
</script>

<style lang="scss">
@import "../../custom.scss";

.home-nav {
  width: 100%;
  position: fixed;
  position: -webkit-fixed;
  top: 0;
  z-index: 1000;
  background: linear-gradient(to bottom, #13609b, #208de2);
  box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 4px;

  .nav.nav-tabs .nav-item .nav-link {
    color: white;
    font-size: 1em;
    font-weight: initial;

    &.active {
      font-weight: bold;
      border-bottom-color: white;
    }
  }
}
</style>
